
  import React from "react"
  import Component from "/Users/david/Sites/freelance/custom-fit/build/src/layouts/index.js"
  import data from "/Users/david/Sites/freelance/custom-fit/build/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js